import { AppRoute } from '@/enums/AppRoute';

export { AppRoute };

export const buildLoginRoute = ({ nextPath }: { nextPath?: string | null } = {}) => {
    if (!nextPath || nextPath === AppRoute.Chats) {
        return AppRoute.Login;
    }

    return `${AppRoute.Login}?next=${encodeURIComponent(nextPath)}`;
};

export const buildChatRoute = ({ chatCode }: { chatCode: string }) => `${AppRoute.Chats}/${encodeURIComponent(chatCode)}`;

export const buildCallRoute = ({ callCode }: { callCode: string }) => `${AppRoute.Calls}?call=${encodeURIComponent(callCode)}`;

export const buildVpnPlusShareCodeRoute = ({ shareCodeId }: { shareCodeId: number }) => `${AppRoute.VpnPlusShare}/${shareCodeId}`;

const VPN_PLUS_SHARE_CODE_ROUTE_PATHNAME_REGEXP = /^\/vpn-plus\/share\/[1-9]\d{0,15}\/?$/;

export const isVpnPlusShareCodeRoutePathname = (pathname: string | null) =>
    Boolean(pathname && VPN_PLUS_SHARE_CODE_ROUTE_PATHNAME_REGEXP.test(pathname));

export const buildRecordingDetailsRoute = ({ recordingCode }: { recordingCode: string }) =>
    `${AppRoute.Recordings}/${encodeURIComponent(recordingCode)}`;

export const buildAdminMailRoute = ({ uid }: { uid?: string | null } = {}) => {
    const normalizedUid = uid?.trim();

    if (!normalizedUid) {
        return AppRoute.AdminMail;
    }

    const searchParams = new URLSearchParams();
    searchParams.set('uid', normalizedUid);

    return `${AppRoute.AdminMail}?${searchParams.toString()}`;
};

export const buildAdminDocsCompatibilityRoute = ({ slug }: { slug?: string | null } = {}) => {
    const normalizedSlug = slug?.trim();

    if (!normalizedSlug) {
        return AppRoute.AdminDocs;
    }

    const searchParams = new URLSearchParams();
    searchParams.set('slug', normalizedSlug);

    return `${AppRoute.AdminDocs}?${searchParams.toString()}`;
};
